import React from 'react';
import DataTableShell from './DataTableShell';
import DataTableGrid from './DataTableGrid';
import DataTableState from './DataTableState';

export default function DataTable({
  title,
  subtitle,
  action = null,
  footer = null,
  columns = [],
  rows = [],
  renderCell,
  rowKey = 'id',
  onRowClick,
  loading = false,
  error = null,
  loadingMessage = 'Memuat data...',
  emptyMessage = 'Belum ada data.',
  errorMessage = 'Terjadi kesalahan saat memuat data.',
}) {
  const safeRows = Array.isArray(rows) ? rows : [];
  const resolvedErrorMessage = typeof error === 'string'
    ? error
    : (error?.message || errorMessage);

  let content = null;
  if (loading) {
    content = <DataTableState state="loading" message={loadingMessage} />;
  } else if (error) {
    content = <DataTableState state="error" message={resolvedErrorMessage} />;
  } else if (!safeRows.length) {
    content = <DataTableState state="empty" message={emptyMessage} />;
  } else {
    content = (
      <DataTableGrid
        columns={columns}
        rows={safeRows}
        renderCell={renderCell}
        rowKey={rowKey}
        onRowClick={onRowClick}
      />
    );
  }

  return (
    <DataTableShell title={title} subtitle={subtitle} action={action} footer={footer}>
      {content}
    </DataTableShell>
  );
}
